import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { IconButton } from "@mui/material";

interface Props {
  onBack?: () => void;
}

export const BackButton: React.FC<Props> = ({ onBack }) => {
  const history = useHistory();

  const handleClick = useCallback(() => {
    if (onBack) {
      onBack();
      return;
    }
    history.goBack();
  }, [onBack, history]);

  return (
    <IconButton sx={{ paddingLeft: "13px" }} onClick={handleClick}>
      <ArrowBackIosIcon />
    </IconButton>
  );
};
